import { render, staticRenderFns } from "./ArticleListe.vue?vue&type=template&id=5f2444d2&scoped=true&"
import script from "./ArticleListe.vue?vue&type=script&lang=js&"
export * from "./ArticleListe.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListe.vue?vue&type=style&index=0&id=5f2444d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2444d2",
  null
  
)

export default component.exports